<app-dialog-base [Title]='"Payed till"|translate' [dialogId]="'setPayedTillDialog'" (onClose)="close()" (onSubmit)="submit()"
                 [width]="'400px'" [height]="'200px'">
  <div class="inputgroup">
    <label>{{'Payed till'|translate}}</label>
    <calendar [name]="'PayedTill'" [(date)]="this.PayedTill" [clear]="true"></calendar>
  </div>
</app-dialog-base>
